module.exports = __webpack_public_path__ + "assets/b7246dcef54ea955486928338a8e8905.woff2";